import React, { useState, useEffect } from "react";
import { IPetPaymentSummaryBannerProps } from "./PetPaymentSummaryBanner.types";
import {
  useFlowData,
  formatString,
  StringFormats,
} from "@adaptis/flow-components";
import "./PetPaymentSummaryBanner.scss";
import { PetType } from "../../util/common-types";
import { getPetQty, removePet, isPetValid } from "../../util/data-store";

export default function PetPaymentSummaryBanner(
  props: IPetPaymentSummaryBannerProps
) {
  type petIcon = { img: string; petQty: number };

  const { getData, setData, getDataFromArray } = useFlowData();
  const [wasAmountToDisplay, setWasAmountToDisplay] = useState(Number);
  const [amountToDisplay, setAmountToDisplay] = useState(Number);
  const [isMultiPets, SetIsMultiPets] = useState(false);
  const [petIcons, setPetIcons] = useState<Array<petIcon>>([]);
  const pets = getData("pets");
  const currentPromoCodeType = getData("root.promoCodeType") ?? "";
  useEffect(() => {
    setWasAmountToDisplay(getData("totalAmounts.wasPriceByYear"));
    setAmountToDisplay(getData("totalAmounts.totalPayToday"));
  }, [amountToDisplay]);

  useEffect(() => {
    setPetIcons(getPetIcons());
  }, []);

  function getPetIcons(): Array<petIcon> {
    let result: Array<petIcon> = [];
    if (pets) {
      let petQty = getPetQty(pets);

      if (petQty.dogQty > 0) {
        result.push({
          img: "images/dog.svg",
          petQty: petQty.dogQty,
        });
      }

      if (petQty.catQty > 0) {
        result.push({
          img: "images/cat.svg",
          petQty: petQty.catQty,
        });
      }

      if (petQty.dogQty > 0 && petQty.catQty > 0) {
        SetIsMultiPets(true);
      }
    }

    return result;
  }

  return (
    <div
      data-testid="PetPaymentSummaryBanner"
      className={
        "flc_pet-payment-summary-banner " + (isMultiPets ? "multi-pets" : "")
      }
    >
      <div className="pet-type-image-wrapper">
        {petIcons &&
          petIcons.map((petIconValue: petIcon, index: number) => {
            return <img src={petIconValue.img} key={index} />;
          })}
      </div>
      <div className="pet-names-wrapper">
        <div>Your Total For</div>
        <div>
          {pets &&
            pets.map((pet: any, index: number) => {
              return <span key={index}>{pet.name}</span>;
            })}
        </div>
      </div>
      <div className="pet-total-wrapper">
        {(currentPromoCodeType && currentPromoCodeType < 3 && wasAmountToDisplay) && <div className="price was-price">
          {formatString(wasAmountToDisplay / 12, StringFormats.Currency)}
        </div>}
        <div className="price">
          {formatString(amountToDisplay, StringFormats.Currency)}
        </div>
        {(currentPromoCodeType && currentPromoCodeType < 3 && pets.length > 1) && <div className="payment-frequency">Per Month</div>}
      </div>
    </div>
  );
}
